import { filter } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { JourneyProductType } from '../../types';
import { STEPS } from '../../constants';

const getSteps = (isFromRefinePrice: boolean, hasRefinedPrice: boolean, journeyProductType: JourneyProductType) => {
  const defaultSteps = [
    STEPS.SPLASH_SCREEN,
    STEPS.ABOUT_YOU,
    STEPS.HOSPITAL_SERVICES,
    STEPS.EXTRAS_SERVICES,
    STEPS.CHOOSE_THE_COVER,
  ];
  // for package journey, splash screen is not shown when navigating from the refine price page
  const skipSplashScreen = (isFromRefinePrice && hasRefinedPrice) || journeyProductType === PRODUCT_TYPE.EXTRAS;

  const filteredServicesSteps =
    journeyProductType === PRODUCT_TYPE.EXTRAS
      ? filter((step: string) => step !== STEPS.HOSPITAL_SERVICES, defaultSteps)
      : defaultSteps;

  const stepsToRender = skipSplashScreen
    ? filter((step: string) => step !== STEPS.SPLASH_SCREEN, filteredServicesSteps)
    : filteredServicesSteps;

  return { skipSplashScreen, steps: stepsToRender };
};

export default getSteps;
